import { render, staticRenderFns } from "./Scroll2Dom.vue?vue&type=template&id=0d841e85&"
import script from "./Scroll2Dom.vue?vue&type=script&lang=js&"
export * from "./Scroll2Dom.vue?vue&type=script&lang=js&"
import style0 from "./Scroll2Dom.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Scroll2Dom.vue"
export default component.exports